export const mockData = [
  {
    id: 1,
    name: 'Room 1',
    img: 'https://cvc-staging.dpgmedia-web.be/rooms/1.jpg',
    digits: 7,
    isActive: true,
    isFinished: true,
    code: 'MzcwMzcwMQ==',
    start: '2020-08-09',
    end: '2020-08-16',
    title: 'The room title',
    body: 'The room description',
    videoUrl:
      'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4',
    registerUrl: 'https://cvc-staging.dpgmedia-web.be/api/rooms/1/register',
  },
  {
    id: 2,
    name: 'Room 2',
    img: 'https://cvc-staging.dpgmedia-web.be/rooms/2.jpg',
    digits: 4,
    isActive: true,
    isFinished: false,
    code: 'MTI5NjM=',
    start: '2020-08-16',
    end: '2020-08-22',
    title: 'The room title but different',
    body: 'The room <span class="bold_mdd">description</span> but different',
    videoUrl: 'https://www.youtube.com/watch?v=j9V78UbdzWI',
    registerUrl: 'https://cvc-staging.dpgmedia-web.be/api/rooms/2/register',
  },
  {
    id: 3,
    name: 'Room 3',
    img: 'https://cvc-staging.dpgmedia-web.be/rooms/3.jpg',
    digits: 4,
    isActive: false,
    code: 'NDAxMQ==',
    start: '2020-08-22',
    end: '2020-08-29',
    title: 'The room title but differenter',
    body: 'The room description lalalal',
    videoUrl: 'https://www.youtube.com/watch?v=j9V78UbdzWI',
    registerUrl: 'https://cvc-staging.dpgmedia-web.be/api/rooms/3/register',
  },
  {
    id: 4,
    name: 'Room 4',
    img: 'https://cvc-staging.dpgmedia-web.be/rooms/5.jpg',
    digits: 4,
    isActive: false,
    code: 'MjMzMjI=',
    start: '2020-08-22',
    end: '2020-08-29',
    title: 'Its a micropig in boot',
    body: 'piglet!',
    videoUrl: 'https://www.youtube.com/watch?v=j9V78UbdzWI',
    registerUrl: 'https://cvc-staging.dpgmedia-web.be/api/rooms/4/register',
  },
];

export const mockData2 = [
  {
    start: '2020-08-11', // TODO: date?
    name: 'Room name 1',
    img: 'https://placekitten.com/680/383',
    isActive: true,
    code: btoa((1234567 * 3).toString()),
    title: 'Bright lights',
    body:
      'You are not the kind of guy who would be at a place like this at this time of the morning. But here you are, and you cannot say that the terrain is entirely unfamiliar, although the details are fuzzy.',
    isFinished: true,
    videoUrl:
      'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4',
  },
  {
    start: '2020-08-11', // TODO: date?
    name: 'Room name 2',
    img: 'https://placekitten.com/1360/766',
    isActive: true,
    code: btoa((1234 * 3).toString()),
    title: 'Big city',
    body:
      'You are at a\n' +
      'nightclub talking to a girl with a shaved head. The club\n' +
      'is either Heartbreak or the Lizard Lounge. All might\n' +
      'come clear if you could just slip into the bathroom and\n' +
      'do a little more Bolivian Marching Powder. Then again\n' +
      'it might not.',
    isFinished: false,
    videoUrl:
      'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4',
  },
  {
    start: '2020-08-11', // TODO: date?
    name: 'Room name 3',
    img: 'https://placekitten.com/453/255',
    isActive: false,
    code: btoa((1234 * 3).toString()),
    title: 'Room 3 Title',
    body: 'Room 3 Body',
    isFinished: false,
    videoUrl:
      'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4',
  },
  {
    start: '2020-08-11', // TODO: date?
    name: 'Room name 4',
    img: 'https://placekitten.com/1813/1021',
    isActive: false,
    code_digits: 4,
    code: btoa((1234 * 3).toString()),
    title: 'Room 4 Title',
    body: 'Room 4 Body',
    isFinished: false,
    videoUrl:
      'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4',
  },
];
